import pathfinder from '@fiverr-private/pathfinder';
import { GoHomeIcon } from '../icons';
import { GoTab, GO_TABS } from './GoSidebar.types';
import { AnnouncementButtonIcon } from './AnnouncementButtonIcon';

interface GoTabConfig {
    id: GoTab;
    Icon: (props: { size: number }) => JSX.Element;
    getHref: (query: { source: string }) => string;
    condition?: (props: { showHubTab: boolean; showCreateTab: boolean }) => boolean;
}

export const GO_TABS_LIST: GoTabConfig[] = [
    {
        id: GO_TABS.HUB,
        Icon: GoHomeIcon,
        getHref: (query) => pathfinder('seller_ai_hub_page', {}, { query }),
        condition: ({ showHubTab }) => showHubTab,
    },
    {
        id: GO_TABS.ANNOUNCEMENTS,
        Icon: AnnouncementButtonIcon,
        getHref: (query) => pathfinder('go_announcements_page', {}, { query }),
    },
];
